export const notation_custoquestion_all = [
    { _id : '01', name : 'Sur une échelle de 0 à 10, de 0 - aucune difficulté à 10 - énormément de difficulté, avez-vous des difficultés à comprendre le sujet traité ?'}, 
    { _id : '02', name : 'Sur une échelle de 0 à 10, de 0 - aucune connaissances à 10 - énormément de connaissances, avez-vous des connaissances sur le sujet traité ?'},
]

export const discipline_all = [
    { _id : 'rugby', name : 'Rugby'}, 
    { _id : 'soccer', name : 'Football'},
    { _id : 'basket', name : 'Basketball'},
    { _id : 'handball', name : 'Handball'},
]

export const subscription_all = [
    { _id : 1, name : 'Commenté'}, 
    { _id : 2, name : 'Action par action'},
    { _id : 3, name : 'Score buteur'},
    { _id : 4, name : 'Score'},
]

export const getActualSeason = () => {
    const currentMonth = new Date().getMonth() + 1; // Les mois sont indexés à partir de 0, donc on ajoute 1 pour obtenir le mois actuel
    const currentYear = new Date().getFullYear();
    const currentDay = new Date().getDate();
  
    if (currentMonth > 8 || (currentMonth === 8 && currentDay >= 1)) {
      return `${currentYear}/${currentYear + 1}`;
    } else {
      return `${currentYear - 1}/${currentYear}`;
    }
};

export const getSeasonDates = (season) => {
    const [startYear, endYear] = season.split("/").map(Number);
    
    const startDate = new Date(startYear, 7, 1); // 1 aout de l'année de début
    const endDate = new Date(endYear, 6, 31); // 31 juillet de l'année de fin
  
    return { startDate, endDate };
};

export const season_all = (function(){

        const startYear = 2022;

        const actualSeason = getActualSeason();
        const endYear = actualSeason.split('/').map(Number)[1];
    
        const seasons = [];
    
        for (let i = startYear; i <= endYear + 2; i++) {
        const seasonId = `${i}/${i + 1}`;
        const seasonName = `${i}/${i + 1}`;
    
        seasons.push({ _id: seasonId, name: seasonName });
        }
    
        return seasons;
})()




export const discipline_actu_all = [
    { _id : 'economie', name : 'Économie'},
    { _id : 'environnement', name : 'Environnement'},
    { _id : 'education', name : 'Éducation'},
    { _id : 'sport', name : 'Sport'},
    { _id : 'societe', name : 'Société'},
    { _id : 'science', name : 'Science'},
    { _id : 'international', name : 'International'},
    { _id : 'culture', name : 'Culture'},
    { _id : 'santé', name : 'Santé'},
    { _id : 'politique', name : 'Politique'},
    { _id : 'technologie', name : 'Technologie'},
]


export const getDays = (nbDays = 25, nbTeamFinalPhase = 0) => {
    const days = []

    if(nbTeamFinalPhase>1){
        days.unshift({ _id : 'final', name : 'final', nbMatchPerDay : 1})
    }

    if(nbTeamFinalPhase>2){
        days.unshift({ _id : 'semi-final', name : 'semi-final', nbMatchPerDay : 2})
    }

    if(nbTeamFinalPhase>4){
        days.unshift({ _id : 'quarter-final', name : 'quarter-final', nbMatchPerDay : 4})
    }

    if (nbTeamFinalPhase > 8) {
        days.unshift({_id: 'round of 16', name: 'round of 16', nbMatchPerDay : 8});
    }

    if (nbTeamFinalPhase > 16) {
        days.unshift({_id: 'round of 32', name: 'round of 32', nbMatchPerDay : 16});
    }

    if (nbTeamFinalPhase > 32) {
        days.unshift({_id: 'round of 64', name: 'round of 64', nbMatchPerDay : 32});
    }

    if (nbTeamFinalPhase > 64) {
        days.unshift({_id: 'round of 128', name: 'round of 128', nbMatchPerDay : 64});
    }

    for(var i = nbDays ; i >= 1 ; i--){
        days.unshift({ _id : i, name : i})
    }

    return days
}
